import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage } from 'react-intl'
import { Button, InputAdornment } from '@material-ui/core'
import { AddNewTaxItemFormValidation } from '../../utils/validationSchema'
import { FormLoader } from '../../components/Loader/FormLoader'
import { formStyles } from '../../components/Invoice/Steps/FormStyles'
import FormTextField from '../FormTextField'
import taxTypes from '../../configurations/tax-types'
import nonTaxableTaxTypes from '../../configurations/non-taxable-tax-types'
import taxSubtypes from '../../configurations/tax-subtypes'
import FormSelectField from '../FormSelectField'
import { calculateDecimal } from '../../utils/helpers'

const TaxItemForm = ({ listingData, onSubmit, currentData, cancelDialog, currentAction, updateParentEntity, locale, netTotal, totalTaxableFees, calculatedFees, valueDifference, currency }) => {
  const classes = formStyles()
  const [currentTaxObj, setCurrentTaxObj] = React.useState({})
  const [currentSubTaxObj, setCurrentSubTaxObj] = React.useState({})
  const [valueEdit, setValueEdit] = React.useState(currentData?.valueEdit || false)
  const [isMounted, setIsMounted] = React.useState(false)
  const formActions = useFormik({
    initialValues: {
      id: '',
      type: '',
      typeName: '',
      subType: '',
      subTypeName: '',
      rate: 0,
      value: 0,
      calculatedValue: 0,
      valueEdit: false,
      fixedAmount: false
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    isInitialValid: false,
    validationSchema: AddNewTaxItemFormValidation,
    onSubmit: ((values, formikHelpers) => {
      onSubmit(values, formikHelpers, updateParentEntity)
    })
  })

  React.useEffect(() => {
      if (!!Object.keys(currentTaxObj || {}).length) {
        formActions.setFieldValue('typeName', currentTaxObj[`name_${locale}`] || '')
        formActions.setFieldValue('valueEdit', !!currentTaxObj?.fixedAmount)
        setValueEdit(!!currentTaxObj?.fixedAmount)
        formActions.setFieldValue('fixedAmount', !!currentTaxObj?.fixedAmount)
        if (!!currentTaxObj?.fixedAmount) {
          formActions.setFieldValue('rate', 0)
        }
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentTaxObj])
  React.useEffect(() => {
      if (!!Object.keys(currentTaxObj || {}).length && !!Object.keys(currentSubTaxObj || {}).length) {
        setValueEdit(!!currentTaxObj?.fixedAmount || !!currentSubTaxObj.fixedAmount)
        formActions.setFieldValue('fixedAmount', !!currentTaxObj?.fixedAmount || !!currentSubTaxObj.fixedAmount)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentSubTaxObj])
  React.useEffect(() => {
      if (!!Object.keys(currentData || {}).length) {
        formActions.setValues({
          id: currentData?.id || '',
          type: currentData?.type || '',
          typeName: currentData?.typeName || '',
          subType: currentData?.subType || '',
          subTypeName: currentData?.subTypeName || '',
          rate: currentData?.rate || 0,
          value: currentData?.value || 0,
          calculatedValue: currentData?.calculatedValue || 0,
          valueEdit: currentData?.valueEdit || false,
          fixedAmount: currentData?.fixedAmount || false
        })
      }
      setTimeout(() => setIsMounted(true), 300)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentData])


  // const RateChange = (event, fieldName) => {
  //   if (!formActions.values.fixedAmount) {
  //     const re = /^[0-9][0-9]?(\.[0-9]*)?$|^100(\.[0]*)?$/
  //     if (event.target.value === '' || re.test(event.target.value)) {
  //       formActions.setFieldValue(fieldName, event.target.value)
  //     }
  //   }
  // }
  const DecimalChange = (event, fieldName) => {
    const re = /^[0-9]*\.?[0-9]*$/
    if (event.target.value === '' || re.test(event.target.value)) {
      formActions.setFieldValue(fieldName, event.target.value)
    }
  }
  const DecimalBlur = (event, fieldName) => {
    if (!formActions.values.fixedAmount || fieldName !== 'rate') {
      let value = calculateDecimal(event.target.value)
      formActions.setFieldValue(fieldName, value)
    }
  }
  // const handleSwitchEditChange = (value, setValue) => {
  //   setValue(value)
  // }

  React.useEffect(() => {
      if (!!isMounted) {
        if (!valueEdit) {
          formActions.setFieldValue('value', formActions.values.calculatedValue)
        }
        formActions.setFieldValue('valueEdit', valueEdit || false)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [valueEdit])


  React.useEffect(() => {
      if (!!isMounted && !formActions.values.fixedAmount) {
        let value = !!formActions.values.rate ? (parseFloat((['T1', 'T2'].includes(formActions.values.type)) ? parseFloat(netTotal) + (parseFloat(valueDifference) || 0) + parseFloat(formActions.values.type === 'T1' ? totalTaxableFees : calculatedFees) : netTotal) || 0) * ((parseFloat(formActions.values.rate) || 0) / 100) : 0.00
        formActions.setFieldValue('calculatedValue', calculateDecimal(value.toString()))
        if (!valueEdit) {
          formActions.setFieldValue('value', calculateDecimal(value.toString()))
        }
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [formActions.values.rate])

  React.useEffect(() => {
      if (!!isMounted) {
        if (!!formActions.values.type) {
          let subTypes = taxSubtypes?.filter(subTitle => subTitle?.TaxtypeReference?.toString() === formActions.values.type?.toString())
          formActions.setFieldValue('subType', subTypes?.length ? subTypes[0]?.key || '' : '')
        } else {
          formActions.setFieldValue('subType', '')
        }
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [formActions.values.type])

  React.useEffect(() => {
      if (!!formActions.values.subType) {
        let subType = taxSubtypes?.filter(subType => subType?.key?.toString() === formActions.values.subType?.toString())
        formActions.setFieldValue('subTypeName', subType?.length ? subType[0][`name_${locale}`] || '' : '')
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [formActions.values.subType])
  return (

    <form onSubmit={formActions.handleSubmit} noValidate autoComplete="off" className={classes.formWrapper}>

      <FormSelectField name={'type'} labelKey={'Fields.label.type'} displayEmpty={true}
                       returnedObj={setCurrentTaxObj}
                       classes={classes}
                       list={[...taxTypes, ...nonTaxableTaxTypes].filter(item => !listingData?.map(oldItem => oldItem.type).filter(oldItem => oldItem !== formActions.values.type).includes(item?.key))}
                       locale={locale} withKeyNext
                       formActions={formActions} required/>

      <FormSelectField name={'subType'} labelKey={'Fields.label.subType'} displayEmpty={!formActions.values.type}
                       classes={classes} returnedObj={setCurrentSubTaxObj}
                       list={!!formActions.values.type
                         ? taxSubtypes?.filter(subTitle => subTitle?.TaxtypeReference?.toString() === formActions.values.type?.toString())
                         : []}
                       locale={locale} withKeyNext
                       formActions={formActions} required/>

      <FormTextField name={'rate'} labelKey={'Fields.label.rate'} classes={classes}
                     formActions={formActions}
                     disabled={!!formActions.values.fixedAmount}
                     onChange={(event) => DecimalChange(event, 'rate')}
                     onBlurFn={(event) => DecimalBlur(event, 'rate')}
                     otherAttributes={{
                       InputProps: {
                         endAdornment: <InputAdornment position="end">%</InputAdornment>
                       }
                     }}/>

      <FormTextField name={'value'} labelKey={'Fields.label.value'} classes={classes}
        // switchEdit={!formActions.values.fixedAmount} switchEditValue={valueEdit}
        // handleSwitchEdit={(value) => handleSwitchEditChange(value, setValueEdit)}
                     disabled={!valueEdit}
                     formActions={formActions}
                     onChange={(event) => DecimalChange(event, 'value')}
                     onBlurFn={(event) => DecimalBlur(event, 'value')}
                     InputAttributes={{
                       startAdornment: <InputAdornment position="start">{currency}</InputAdornment>
                     }}/>

      <div className={classes.FormSubmitRow}>
        <Button type="submit" variant='contained' size={'large'} color={'secondary'}
                onClick={formActions.handleSubmit}
                disabled={formActions.isSubmitting || !formActions.isValid}
        >
          <FormattedMessage id={`AddNewDialog.AddNewRecord.${currentAction}`}/>
        </Button>
        <Button variant='outlined' color='secondary'
                onClick={cancelDialog} className={'cancel'}>
          <FormattedMessage id='invoiceSteps.Cancel'/>
        </Button>
      </div>
      {!!formActions.isSubmitting && <FormLoader loading={true}/>}
    </form>
  )
}

export default TaxItemForm
